/**
 * Module-level grab anchor for board-to-canvas and drag-layer drags.
 * Set on dragstart via useHTML5DragStart, read by ReactDndDragLayer to position
 * the drag preview relative to where the user grabbed the source element.
 * Values are normalized (0–1) fractions of the source element's dimensions.
 */
let grabAnchor = { x: 0, y: 0 };

export const setDragGrabAnchor = (x: number, y: number): void => {
  grabAnchor = { x, y };
};

export const getDragGrabAnchor = (): { x: number; y: number } => grabAnchor;
